import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledButton,
  ExtendedBox,
  ExtendedFlex,
  Image,
  Heading,
  Body,
} from '../../coreui';

import Graph from '../assets/table_compare.png';

class ModalLink extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.constructModalContent = this.constructModalContent.bind(this);
  }

  constructModalContent() {
    const { content } = this.props;
    return (
      <ExtendedBox>
        <ExtendedFlex
          height="100%"
          align="center"
          flexDirection="row"
          display="inline"
          minHeight="inherit"
          justify="center"
        >
          <Heading
            type="H3"
            textAlign="center"
            mx="auto"
            display="block"
          >
            COMPARING REIT TYPES
          </Heading>
          <Image
            width={1}
            src={Graph}
          />
          <Body
            type="B3"
            display="block"
          >
            {content}
          </Body>
        </ExtendedFlex>
      </ExtendedBox>
    );
  }

  handleClick(e) {
    e.preventDefault();
    this.props.handleClick(this.constructModalContent());
  }

  render() {
    const { title } = this.props;

    return (
      <ExtendedBox>
        <StyledButton
          type="L4"
          fontSize={[8, 8, 8, 10, 10]}
          onClick={this.handleClick}
        >
          {title}
        </StyledButton>
      </ExtendedBox>
    );
  }
}

ModalLink.propTypes = {
  content: PropTypes.any,
  title: PropTypes.string,
  handleClick: PropTypes.func,
};

export default ModalLink;
